import type { GroupChannelProps } from '@sendbird/uikit-react-native';
import type { SendbirdChatSDK } from '@sendbird/uikit-utils';

import type { Guide } from '../../guidance/types/Guide';

export type SearchItem = GroupChannelProps['MessageList']['searchItem'];

export interface GuideMessagingDto {
    user: SendbirdUser;
    unreadCount: number;
    currentChat: Chat;
}

export interface SendbirdUser {
    userId: string;
    accessToken: string;
    nickname: string;
    profileUrl?: string;
}

export interface SendbirdChannel {
    channelUrl: string;
}

export interface Chat {
    guide: Guide;
    channel: SendbirdChannel;
}

export enum MessagingSnapshotContext {
    HOME = 'home',
    MY_GUIDE = 'my_guide',
}

export interface SendbirdSdk {
    sdk: SendbirdChatSDK | null;
    isLoading: boolean;
}
